module.exports = __webpack_public_path__ + "static/img/top.b51237c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/17/top.jpg
// module id = Ne6v
// module chunks = 27